import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { WIDGETS_B2B_API_URL } from '../tokens/widgets-b2b-api-url.token';
import { WIDGETS_B2C_API_URL } from '../tokens/widgets-b2c-api-url.token';
import { AuthService } from '../services/auth.service';
import { ClassService } from '../services/class.service';
import { DialogService } from '../services/dialog.service';
import { FormSubmissionService } from '../services/form-submission.service';
import { LeadCaptureService } from '../services/lead-capture.service';
import { ScheduleService } from '../services/schedule.service';
import { SubscriptionService } from '../services/subscription.service';
import { TourBookingService } from '../services/tour-booking.service';
import { TrialBookingService } from '../services/trial-booking.service';
import { UtilsService } from '../services/utils.service';
import { WidgetService } from '../services/widget.service';
import {
  WIDGETS_RECAPTCHA_CONFIG,
  WidgetsRecaptchaConfig,
} from '../tokens/widgets-recaptcha-config.token';

export interface ProvideWidgetsOptions {
  b2cApiUrl: string;
  b2bApiUrl: string;
  recaptcha?: WidgetsRecaptchaConfig;
}

export function provideWidgets(
  options: ProvideWidgetsOptions,
): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: WIDGETS_B2C_API_URL, useValue: options.b2cApiUrl },
    { provide: WIDGETS_B2B_API_URL, useValue: options.b2bApiUrl },
    {
      provide: WIDGETS_RECAPTCHA_CONFIG,
      useValue: options.recaptcha ?? { v3SiteKey: '', v2SiteKey: '' },
    },
    AuthService,
    ClassService,
    DialogService,
    FormSubmissionService,
    LeadCaptureService,
    ScheduleService,
    SubscriptionService,
    TourBookingService,
    TrialBookingService,
    UtilsService,
    WidgetService,
  ]);
}

